import React from 'react';
import { IconNames } from '../../../common/components/Icon/IconNames';
import { Icon, Modal, Text } from '../../../common/components';

export type RegistryModalProps = {
  isShown: boolean;
  onHide: () => void;
  iconName: IconNames;
  title: string;
  description: string;
};

export const RegistryDashModal: React.FC<RegistryModalProps> = ({
  isShown,
  onHide,
  iconName,
  title,
  description,
}) => (
  <Modal isShown={isShown} onHide={onHide} className='RegistryDashModal'>
    <div className="RegistryDashModal__header mb-2">
      <Icon name={iconName} color="AccentOrange" className="RegistryDashModal__icon" />
      <Text size="h2">{title}</Text>
    </div>

    <Text size="body-medium" color="Neutral700" className="mb-3">
      {description}
    </Text>
  </Modal>
);

export default RegistryDashModal;
